import { trackEvent } from 'lib/ui-analytics';
import { createUserInteraction } from '../utils';
import { TRACKING_ACTION, TRACKING_INTERACTION } from '../Constants';

export const utagGuestClicked = () => {
	const base = {
		eventType: TRACKING_ACTION.INTERACTION,
		interaction: TRACKING_INTERACTION.FILTERS.NUMBER_GUEST,
	};

	const interactionType = base;

	const userInteractionEvent = createUserInteraction(interactionType);
	trackEvent(userInteractionEvent);
};
